import { render, staticRenderFns } from "./TabelaBalancete.vue?vue&type=template&id=610befb0&"
import script from "./TabelaBalancete.vue?vue&type=script&lang=js&"
export * from "./TabelaBalancete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports